import Error from '../model/Error';
import WaitListEntry from '../dto/offering/WaitListEntry';
import axios from 'axios';

export default class WaitListRepository {
    static findAll(appointmentSeriesId, startDate, startTime) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/appointments/${appointmentSeriesId}/${startDate}/${startTime}/waitlist`)
                .then(response => resolve(response.data.data.map(data => WaitListEntry.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findByMemberId(memberId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/members/${memberId}/waitlist`)
                .then(response => resolve(response.data.data.map(data => WaitListEntry.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static prioritizeUp(waitListEntry) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/wait-list-entry/${waitListEntry.id}`, {
                    priorityUp: true,
                })
                .then(response => resolve(response.data.data.map(data => WaitListEntry.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static prioritizeDown(waitListEntry) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/wait-list-entry/${waitListEntry.id}`, {
                    priorityDown: true,
                })
                .then(response => resolve(response.data.data.map(data => WaitListEntry.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(waitListEntry) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/wait-list-entry/${waitListEntry.id}`, {
                    delete: true,
                })
                .then(response => resolve(response.data.data.map(data => WaitListEntry.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
